import { Box } from '@chakra-ui/react';
import { createBrowserRouter } from 'react-router-dom';
import Login from './pages/login/login';
import Store from './pages/store/store';
import Cart from './pages/cart/cart';
import Admin from './pages/admin/admin';
import Users from './pages/admin/users';
import Facilities from './pages/admin/facilities';
import Categories from './pages/admin/categories';
import Products from './pages/admin/products';
import Addproduct from './pages/admin/addproduct';
import OrderConfirmation from './pages/store/confirm';
import Editproduct from './pages/admin/editproduct';
import PrivateRoute from './component/privateRouter';
import AdminRoute from './component/adminRouter';
import Order from './pages/order/order';
import AdminOrder from './pages/admin/orders';
import Orderdetail from './pages/order/orderdetail';
import ProfilePage from './pages/profile/profile';
import AdminOrderDetail from './pages/admin/orderdetail';
import EditOrder from './pages/order/EditOrder';
import Reports from './pages/admin/reports';
import AuditLog from './pages/admin/auditlog';
import Fishbowl from './pages/admin/fishbowl';
import PriceGroups from './pages/admin/priceGroups';
import EditPriceGroup from './pages/admin/editPriceGroup';
import Catalog from './pages/catalog/catalog';
import ContactPage from './pages/contact/contact';

export const router = createBrowserRouter([
	{
		path: '/catalog',
		element: <Catalog />,
	},
	{
		path: '/contact',
		element: <ContactPage />,
	},
	{
		path: '/login',
		element: <Login />,
	},
	{
		path: '/',
		element: <Login />,
	},
	{
		path: '/store/*',
		element: (
			<PrivateRoute>
				<Store />
			</PrivateRoute>
		),
	},
	{
		path: '/cart/*',
		element: (
			<PrivateRoute>
				<Cart />
			</PrivateRoute>
		),
	},
	{
		path: '/confirm/*',
		element: (
			<PrivateRoute>
				<OrderConfirmation />
			</PrivateRoute>
		),
	},
	{
		path: '/order',
		element: (
			<PrivateRoute>
				<Order />
			</PrivateRoute>
		),
	},
	{
		path: '/order/edit/:order_id',
		element: (
			<PrivateRoute>
				<EditOrder />
			</PrivateRoute>
		),
	},
	{
		path: '/order/:order_id',
		element: (
			<PrivateRoute>
				<Orderdetail />
			</PrivateRoute>
		),
	},
	{
		path: '/profile',
		element: (
			<PrivateRoute>
				<ProfilePage />
			</PrivateRoute>
		),
	},
	{
		path: '/admin/*',
		element: (
			<AdminRoute>
				<Admin />
			</AdminRoute>
		),
	},
	{
		path: '/admin/users/',
		element: (
			<AdminRoute>
				<Users />
			</AdminRoute>
		),
	},
	{
		path: '/admin/products/',
		element: (
			<AdminRoute>
				<Products />
			</AdminRoute>
		),
	},
	{
		path: '/admin/facilities/',
		element: (
			<AdminRoute>
				<Facilities />
			</AdminRoute>
		),
	},
	{
		path: '/admin/categories/',
		element: (
			<AdminRoute>
				<Categories />
			</AdminRoute>
		),
	},
	{
		path: '/admin/orders',
		element: (
			<AdminRoute>
				<AdminOrder />
			</AdminRoute>
		),
	},
	{
		path: '/admin/orders/:order_id',
		element: (
			<AdminRoute>
				<AdminOrderDetail />
			</AdminRoute>
		),
	},
	{
		path: '/admin/reports',
		element: (
			<AdminRoute>
				<Reports />
			</AdminRoute>
		),
	},
	{
		path: '/admin/auditlog',
		element: (
			<AdminRoute>
				<AuditLog />
			</AdminRoute>
		),
	},
	{
		path: '/admin/fishbowl',
		element: (
			<AdminRoute>
				<Fishbowl />
			</AdminRoute>
		),
	},
	{
		path: '/admin/price-groups',
		element: (
			<AdminRoute>
				<PriceGroups />
			</AdminRoute>
		),
	},
	{
		path: '/admin/price-groups/:id',
		element: (
			<AdminRoute>
				<EditPriceGroup />
			</AdminRoute>
		),
	},
	{
		path: '/admin/products/create-product',
		element: (
			<AdminRoute>
				<Addproduct />
			</AdminRoute>
		),
	},
	{
		path: '/admin/products/edit-product/:product_id',
		element: (
			<AdminRoute>
				<Editproduct />
			</AdminRoute>
		),
	},
]);
